import { render, staticRenderFns } from "./labCommont.vue?vue&type=template&id=701e8939"
import script from "./labCommont.vue?vue&type=script&lang=js"
export * from "./labCommont.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports